import { render, staticRenderFns } from "./ItensMenu.vue?vue&type=template&id=ede13618&scoped=true&"
import script from "./ItensMenu.vue?vue&type=script&lang=js&"
export * from "./ItensMenu.vue?vue&type=script&lang=js&"
import style0 from "./ItensMenu.vue?vue&type=style&index=0&id=ede13618&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede13618",
  null
  
)

export default component.exports